export const sendGA4Event = (eventName, params = {}) => {
    if (typeof window !== 'undefined') {
        if (window.gtag) {
            window.gtag('event', eventName, params);
        } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: eventName, ...params });
        }
    }
};